// extracted by mini-css-extract-plugin
export default {"topic":"trending_topic__JOgwB","trending_negative":"trending_trending_negative__lyzfH","trending_positive":"trending_trending_positive__iW0Mq"};